import {Component, input} from '@angular/core';
import {SvgSpriteIcon} from '../svg-sprite';

@Component({
  selector: 'lib-interaction-message',
  imports: [],
  templateUrl: './interaction-message.component.html',
  styleUrl: './interaction-message.component.scss'
})
export class InteractionMessageComponent {
  readonly tapMessage = input('Tap to interact');
  readonly clickMessage = input('Click to interact');

  readonly tapIcon = SvgSpriteIcon.Tap;
  readonly clickIcon = SvgSpriteIcon.Click;
}
